import React from 'react';

/**
 * Componente de Loader unificado para o Aluno Conectado.
 * Reutiliza a mesma estrutura HTML e as classes CSS globais definidas no cabeçalho do index.html
 * para garantir transição e visual idênticos sem duplicação de estilos.
 */
export function AcBootLoader() {
  return (
    <div id="ac-boot-loader" aria-label="Carregando" role="status">
      <div className="ac-boot-mark">
        <img className="ac-boot-logo" src="/icons/logo-pwa-white.svg" alt="" />
      </div>
    </div>
  );
}
